import { render, staticRenderFns } from "./customer-login.vue?vue&type=template&id=5f1f70f5"
import script from "./customer-login.vue?vue&type=script&lang=js"
export * from "./customer-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports